import { api } from "assets/scripts/utilities/api-clients";

const prepareTemplate = (template) => {
  const seller = template.seller_info;

  return {
    ...template,

    seller_info: seller
      ? {
          _id: seller._id,
          name: seller.shop_name || seller.name,
        }
      : null,

    voucher_type:
      typeof template.voucher_type === "object"
        ? template.voucher_type.value
        : template.voucher_type,
  };
};

const prepareTemplateFormData = (template, file) => {
  const payload = prepareTemplate(template);
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    formData.append(
      key,
      typeof value === "object" ? JSON.stringify(value) : String(value),
    );
  });

  if (file) {
    formData.append("file", file);
  }

  return formData;
};

export const index = async ({
  params: { showMessage = false, ...restParams } = {},
  ...restOptions
} = {}) => {
  const response = await api.get("/kam/pdf-templates", {
    params: {
      showMessage,
      ...restParams,
    },
    ...restOptions,
  });

  return response;
};

export const get = async (id) => {
  const response = await api.get(`/kam/template/${id}`);

  return response;
};

export const post = async (pdfTemplate, file) => {
  const formData = prepareTemplateFormData(pdfTemplate, file);

  const response = await api.post("/kam/create", formData);

  return response;
};

export const put = async (pdfTemplate) => {
  const payload = prepareTemplate(pdfTemplate);
  const { _id: templateId } = payload;

  const response = await api.put(`/kam/template/${templateId}`, payload);

  return response;
};

export const postConvertPDFToHTML = async (pdf) => {
  const payload = new FormData();

  payload.append("file", pdf);

  const response = await api.post("/kam/pdf-to-html", payload);

  return response;
};

export const getInUseTemplateStatus = async (vendorId, excludeTemplateId) => {
  const response = await api.get(
    `/kam/pdf-templates/check-in-use/${vendorId}`,
    {
      params: {
        exclude_template_id: excludeTemplateId || undefined,
      },
    },
  );

  return response;
};
